import { TunnelStep } from '../model/tunnel-step-type';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { BaseInstallationComponent } from '../common/base-installation/base-installation.component';
import { TunnelDataState } from 'src/app/stores/tunnel/model/tunnel-data-state';
import { BaseFundingComponent } from '../common/base-funding/base-funding.component';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { MODAL } from 'src/app/services/modal.service';
import { FidelityCardTypeEnum } from 'src/app/services/fidelity/fidelity';
import { BathroomConfigurationData } from 'src/app/stores/tunnel/model/configuration-data/bathroom-configuration-data';
import { BathroomTunnelProductsComponent } from './bathroom-tunnel-products/bathroom-tunnel-products.component';
import { environment } from 'src/environments/environment';
import { BathroomTunnelConceptionComponent } from './bathroom-tunnel-conception/bathroom-tunnel-conception.component';

/**
 * Étapes du tunnel de vente SDB Kentia 2D (CONFIG_CONTEXT.BATHROOM_V2).
 * Configurateur à catalogue interne, sans BOM ; les gardes portent sur la liste de produits.
 */
function isProductsEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.BATHROOM_V2) as BathroomConfigurationData;
  return !configuration?.products || configuration.products.length === 0;
}

export const BATHROOM_TUNNEL_STEPS_V2: TunnelStep[] = [
  {
    component: BathroomTunnelConceptionComponent,
    context: CONFIG_CONTEXT.BATHROOM_V2,
    title: 'Configuration',
    hideProductList: true,
    hidePreviousStepAction: true,
    hideDiscountAction: true,
    canPrint: false,
    skipCheckBomEmpty: true,
    placeholderImageSrc: 'assets/img/bathroom/kentia_1.png',
  },
  {
    component: BathroomTunnelProductsComponent,
    context: CONFIG_CONTEXT.BATHROOM_V2,
    title: "Liste d'achat",
    hideProductList: true,
    hidePreviousStepAction: true,
    displayAddProductButton: true,
    canPrint: true, // Va imprimer la liste d'achat et non le PDF de récapitulatif
    isDisabled: stateValue => {
      return isProductsEmpty(stateValue);
    },
    placeholderImageSrc: 'assets/img/bathroom/kentia_1.png',
  },
  ...(!environment.installationSpecifics.bathroomV2.disableInstallation
    ? [
        {
          component: BaseInstallationComponent,
          context: CONFIG_CONTEXT.BATHROOM_V2,
          title: 'Pose',
          canPrint: false,
          readonlyProductList: true,
          hideProductList: true,
          isDisabled: stateValue => {
            return isProductsEmpty(stateValue);
          },
          placeholderImageSrc: 'assets/img/bathroom/kentia_2.png',
        },
      ]
    : []),
  {
    component: BaseFundingComponent,
    context: CONFIG_CONTEXT.BATHROOM_V2,
    title: 'Financement',
    canPrint: false,
    hideProductList: true,
    readonlyProductList: true,
    isDisabled: (stateValue, featureSettings) => {
      if (!featureSettings.financement) {
        return isProductsEmpty(stateValue);
      }

      return (
        stateValue.currentPricing?.totalWithoutFunding === undefined ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        isProductsEmpty(stateValue)
      );
    },
    placeholderImageSrc: 'assets/img/bathroom/kentia_3.png',
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.BATHROOM_V2,
    title: 'Validation',
    canPrint: true,
    hideProductList: true,
    readonlyProductList: true,
    modalToOpen: MODAL.FIDELITY_ADVERTISMENT,
    skipModalToOpen: (stateValue, featureSettings) => {
      return (
        !featureSettings.fidelity ||
        (stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE &&
          stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)
      );
    },
    isDisabled: (stateValue, featureSettings) => {
      return (
        (featureSettings.financement
          ? stateValue.currentPricing?.totalWithFunding === undefined ||
            stateValue.currentFunding?.downPayment === undefined
          : stateValue.currentPricing?.totalWithoutFunding === undefined) ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        stateValue.fidelityLoading ||
        (featureSettings.financement && stateValue.fundingLoading) ||
        isProductsEmpty(stateValue)
      );
    },
    placeholderImageSrc: 'assets/img/bathroom/kentia_4.png',
  },
];
